import React, { useEffect, useState } from "react";
import { Card, Button, Progress, Typography, Space } from "antd";
import {
  PauseOutlined,
  PlayCircleOutlined,
  StopOutlined,
  MinusOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import { useSocketProvider } from "src/containers/SocketProvider";
import { useSelector } from "react-redux";
import { useQueryParams } from "src/helpers/params";
const { Text } = Typography;



export default function BroadcastFloatingPanel() {
  const profile = useSelector((state) => state?.Profile?.response?.full);
  const reader = useSelector((s) => s?.axiosTemp["kirim_pesan_blast_selector"]);
  const [progress, setProgress] = useState(0);
  const [sent, setSent] = useState(0);
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState("Idle");
  const [logs, setLogs] = useState([]);
  const [isPaused, setIsPaused] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [visible, setVisible] = useState(false);
  const [estimasi, setEstimasi] = useState(null);

  const { socket } = useSocketProvider();
  const params = useQueryParams();

  const sessionId = profile?.id_reseller || params?.id_reseller;

  //   console.log(sessionId);

  useEffect(() => {
    if (!socket) return;

    socket.on("wa_blast:progress", (data) => {
      setSent(data.sent);
      setTotal(data.total);
      const p = Math.round((data.sent / data.total) * 100);
      setProgress(p);
    });

    socket.on("wa_blast:eta", (data) => {
      setEstimasi(data);
    });

    socket.on("wa_blast:status", (data) => {
      setLogs((prev) => [...prev, data.message]);
      if (data?.state === "finished") {
        // if (data?.sent === data?.total) {
        setTimeout(() => {
          setVisible(false);
        }, 1000);

        // }
      }
    });

    socket.on("wa_blast:state", (data) => {
      setStatus(data.state);
    });

    return () => {
      socket.off("wa_blast:progress");
      socket.off("wa_blast:status");
      socket.off("wa_blast:state");
      socket.off("wa_blast:eta");
    };
  }, [sessionId, socket]);

  useEffect(() => {
    if (reader?.status === "success") {
      setVisible(true);
      /* bersihkan logging setelah proses di mulai */
      setLogs([]);
      setSent(0);
      setTotal(0);
    }
  }, [reader]);

  const handlePause = () => {
    socket.emit("wa_blast:pause", { sessionId });
    setStatus("Paused");
    setIsPaused(true);
  };

  const handleResume = () => {
    socket.emit("wa_blast:resume", { sessionId });
    setStatus("Running");
    setIsPaused(false);
  };

  const handleCancel = () => {
    socket.emit("wa_blast:cancel", { sessionId });
    setStatus("Canceled");
    setVisible(false);
    setIsPaused(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 2000,
        width: isMinimized ? 280 : 360,
      }}
    >
      <Card
        size="small"
        title={<Text strong>Broadcast Progress</Text>}
        extra={
          <Space>
            <Button
              size="small"
              icon={isMinimized ? <AppstoreOutlined /> : <MinusOutlined />}
              onClick={() => setIsMinimized(!isMinimized)}
            />

            <Button size="small" danger onClick={() => setVisible(false)}>
              X
            </Button>
          </Space>
        }
        style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.25)", borderRadius: 10 }}
      >
        {/* MINIMIZED MODE */}
        {isMinimized ? (
          <div>
            <Progress percent={progress} size="small" />
            <Text type="secondary">
              {sent} / {total} pesan
            </Text>
          </div>
        ) : (
          <>
            <Progress
              percent={progress}
              status={status === "Canceled" ? "exception" : "active"}
            />

            <Text>
              Status: <b>{status}</b>
            </Text>
            <br />
            <Text type="secondary">
              {sent} / {total} pesan terkirim
            </Text>

            {estimasi && (
              <div style={{ marginTop: 8 }}>
                <Text type="secondary">
                  ⏱ Estimasi selesai: <b>{estimasi.eta}</b>
                </Text>
                <br />
                <Text type="secondary">
                  ⌛ Waktu berjalan: {estimasi.elapsed}
                </Text>
              </div>
            )}

            <div style={{ marginTop: 12 }}>
              <Space>
                {!isPaused ? (
                  <Button
                    size="small"
                    icon={<PauseOutlined />}
                    onClick={handlePause}
                  >
                    Pause
                  </Button>
                ) : (
                  <Button
                    size="small"
                    type="primary"
                    icon={<PlayCircleOutlined />}
                    onClick={handleResume}
                  >
                    Resume
                  </Button>
                )}

                <Button
                  size="small"
                  danger
                  icon={<StopOutlined />}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </Space>
            </div>

            <div
              style={{
                marginTop: 12,
                background: "#fafafa",
                height: 150,
                padding: 8,
                overflowY: "auto",
                borderRadius: 6,
                fontSize: 12,
              }}
            >
              {logs.map((l, i) => (
                <div key={i}>
                  <Text>{l}</Text>
                </div>
              ))}
            </div>
          </>
        )}
      </Card>
    </div>
  );
}
